import { render, staticRenderFns } from "./MessageWall.vue?vue&type=template&id=67219b5f&"
import script from "./MessageWall.vue?vue&type=script&lang=js&"
export * from "./MessageWall.vue?vue&type=script&lang=js&"
import style0 from "./MessageWall.vue?vue&type=style&index=0&id=67219b5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports